<template>
  <v-card class="mx-auto" min-height="500">
        <v-img
          :src="item.src"
          class="white--text align-end text-left"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
          height="200px"
          row
        >
          <!-- <v-card-title  v-text="group.groupName" ></v-card-title> -->
        </v-img>
      <v-card-text>
          <v-list-item>
            <v-col cols="4">
              <v-list-item-content class="align-start font-weight-bold">グループ名：</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ group.groupName }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-col cols="4">
              <v-list-item-content class="align-start font-weight-bold">募集要項：</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ group.groupRequirements }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-col cols="4">
              <v-list-item-content class="align-start font-weight-bold">グループメンバー数：</v-list-item-content>
            </v-col>
            <v-col cols="1">
            <v-list-item-content id="fire" :style="{ cursor: 'pointer',color: 'blue'}" @click.stop="toggleGroupMemberListModal">{{ numberOfGroupMember }}</v-list-item-content>
            </v-col>
          </v-list-item>
          <v-list-item v-if="!isGroupMember">
            <v-col cols="4">
              <v-list-item-content class="align-start font-weight-bold">グループジョブ数：</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ numberOfGroupJob }}</v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-col cols="4">
              <v-list-item-content class="align-start font-weight-bold">グループリーダー：</v-list-item-content>
            </v-col>
            <v-list-item-content class="align-start">{{ nameOfGroupLeader }}</v-list-item-content>
          </v-list-item>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="isGroupLeader()" @click.stop="toggleGroupJobFormModal" color="accent" dark>グループジョブを作成する</v-btn>
      <v-btn v-if="!isGroupMember" color="accent" @click="joinGroupConfirm()">参加する</v-btn>
      <v-btn v-if="isGroupLeader()" @click.stop="toggleGroupFormModal" color="primary" >編集する</v-btn>
      <v-btn v-if="isGroupMember" color="warning" @click="leaveGroupConfirm(group)">脱退する</v-btn>
    </v-card-actions>
  <v-dialog v-model="$store.state.groupFormModal" max-width="500" persistent>
    <group-form-component :form="groupForm" :editGroup="group">
    </group-form-component>
  </v-dialog>
  <v-dialog v-model="$store.state.groupMemberListModal" max-width="500">
    <group-member-list-component/>
  </v-dialog>
  </v-card>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
import GroupFormComponent from './GroupForm.vue'
import GroupMemberListComponent from './GroupMemberList.vue'
export default {
  components: {
    GroupFormComponent,
    GroupMemberListComponent
  },
  created(){
    this.$store.state.groupMemberListModal = false;
  },
  computed: {
    memberName(){
      return this.myGroupMembers[0] ? this.myGroupMembers[0].userName : ""
    },
    isGroupMember(){
        const loginUserId = this.loginUserId
        return this.myGroupMembers.some(member => member.userId === loginUserId)
    },
    numberOfGroupMember(){
      return this.group.groupMemberList ? this.group.groupMemberList.length : ""
    },
    numberOfGroupJob(){
      return this.group.groupJobList ? this.group.groupJobList.length : ""
    },
    numberOfGroupChat(){
      return this.group.groupChatList ? this.group.groupChatList.length : ""
    },
    nameOfGroupLeader(){
      return this.group.groupLeaderData ? this.group.groupLeaderData.userName : ""
    },
    ...mapGetters(['group','myGroupMembers','loginUserId','job/groupJobs']),
  },
  data () {
      return {
        item: { title: '筋トレグループ', src: 'https://img.freepik.com/free-photo/real-estate-desk-with-keys_23-2147653337.jpg?size=626&ext=jpg&ga=GA1.2.1435548227.1602438076', flex: 6,link: {name: 'EditGroup'} },
        groupForm: {
          title: 'グループ編集',
          subTitle: 'グループ名と募集要項を変更することができます',
          buttonText: 'グループ情報の更新'
        },
      }
  },
  methods:{
    joinGroupConfirm(){
        if(confirm(`本当に「${this.group.groupName}」に参加しますか？`)){
          const item = this.group
          item.numberOfGroupJobs = item.groupJobList.length
          item.numberOfGroupMembers = item.groupMemberList.length + 1;
          item.leaderOfGroup = item.groupLeaderData.userName
          item.joined = true;
          this.joinTheGroup(item);
          this.$router.push({ name: "GroupIndex"})

        }},
    isGroupLeader(){
       if(this.group.groupLeaderData){
         if(this.group.groupLeaderData.userId == this.loginUserId ){
           return true
         } 
         else {
           return false
         }
       }
       else return ""
     },
    // グループを脱退するメソッド
      leaveGroupConfirm(item){
        if(confirm(`本当に「 ${item.groupName} 」を脱退しますか？`)){
          if(this.myGroupMembers.length == 1){
            // グループの所属人数が1なら脱退時にグループを削除する
            this.deleteGroup(item);
            this.$router.push({name: 'GroupIndex'});
          }else{
            // そうでなければグループをただ脱退する
            this.releaseGroups(item);
            this.$router.push({name: 'GroupIndex'});
          }
        }
      },
    ...mapActions(['deleteGroup','toggleGroupMemberListModal','toggleGroupFormModal','fetchTheGroup','fetchMyGroupMembers','updateMyGroup','releaseGroups','joinTheGroup','toggleGroupJobFormModal',])
  }
}
</script>

